import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { addToSaved, removeFromSaved } from './saved.actions';
import { selectInstitutions } from './saved.selectors';
import { Institution } from 'src/generated/graphql';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SavedFacadeService {
  public get institutions$(): Observable<Institution[]> {
    return this.store.select(selectInstitutions);
  }

  constructor(private store: Store) {}

  public addToSaved(institution: Institution): void {
    this.store.dispatch(addToSaved({ institution }));
  }

  public removeFromSaved(institution: Institution): void {
    this.store.dispatch(removeFromSaved({ institution }));
  }
}
